/** Maximum size in bytes for a single uploaded file (must match server `MAX_UPLOAD_FILE_BYTES`). */
export const MAX_UPLOAD_FILE_BYTES = 10 * 1024 * 1024

export const MAX_UPLOAD_FILE_MB = 10

export function assertFileWithinUploadLimit(file: File | Blob): void {
  if (file.size > MAX_UPLOAD_FILE_BYTES) {
    throw new Error(`File must be ${MAX_UPLOAD_FILE_MB} MB or smaller.`)
  }
}
